import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Intercom from '@intercom/messenger-js-sdk';
import { getUserDetails } from "../utils/utils";

export function InterCom() {
  const { publisherId = '' } = useParams();
  useEffect(() => {
    async function initIntercom() {
      const userDetails = await getUserDetails(publisherId);
      const { email, userId } = userDetails;
      Intercom({
        app_id: 'mvyefqq1', // this needs to be moved to REACT_APP env variable during build time
        user_id: userId,
        email: email,
      });
    }
    initIntercom()
  }, [])

  return <></>
}
